import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import {MatSnackBar} from '@angular/material/snack-bar';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
@Injectable()
export class PromptUpdateService {

  constructor(public updates: SwUpdate,private snackbar: MatSnackBar) {}

  public checkForUpdates(){
      this.updates.available.subscribe(event => {
        const snack = this.snackbar.open('New version available!', 'Refresh', {panelClass : ['m10-orange','default-m10-margin']});
        snack.onAction().pipe(switchMap(() => this.updates.activateUpdate())).subscribe(() => {
          window.location.reload();
        });
        setTimeout(() => {
          snack.dismiss();
        }, 10000);
      });
  }
}
